module.exports = "<p>\n  dd-combo works!\n</p>\n"